import type { AuthenticationModuleClientDeps, AuthenticationModuleClientType } from '../contracts/client';

export async function load(
  implementation: 'cet' | 'mocked',
  deps: AuthenticationModuleClientDeps
): Promise<AuthenticationModuleClientType> {
  switch (implementation) {
    case 'cet':
      return (await import('../implementations/cet/src/client')).create(deps);
    case 'mocked':
      return (await import('../implementations/mocked/src/client')).create(deps);
    default:
      throw new Error(`Unknown authentication client implementation: ${implementation || '<missing>'}`);
  }
}
